import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Col, Container, Row } from 'reactstrap';
import { routes } from '../../routers/routes';
import { BreadcrumbsProps } from '../../types/CoreComponents';
import SvgIcon from '../SvgIcon';

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ mainTitle, parent, parentsArray, tooltip }) => {
  return (
    <Container fluid>
      <div className="page-title">
        <Row className="d-flex justify-content-between align-items-center">
          <Col xl="4" sm="7" className="box-col-3">
            <span className="position-relative d-inline-block">
              <h3 style={{ paddingRight: '24px' }}>{mainTitle}</h3>
              {tooltip}
            </span>
          </Col>
          {/* <Col xs="5" className="d-none d-xl-block">
            <SubHeader />
          </Col> */}
          <Col xl="4" sm="5" className="box-col-4">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={routes.Dashboard.Default}>
                  <SvgIcon className="stroke-icon" iconId="stroke-home" />
                </Link>
              </BreadcrumbItem>
              {parent && !parentsArray && <BreadcrumbItem>{parent}</BreadcrumbItem>}
              {parentsArray &&
                !parent &&
                parentsArray.map((p) => (
                  <BreadcrumbItem>
                    <Link to={p.link}>{p.name}</Link>
                  </BreadcrumbItem>
                ))}
              <BreadcrumbItem active>{mainTitle}</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
